// extracted by mini-css-extract-plugin
export default {"container":"rightsListGen_container__PhXPd","tileContainer":"rightsListGen_tileContainer__NhcQn","tileContainerLoad":"rightsListGen_tileContainerLoad__wKJBK"};